module.exports = __webpack_public_path__ + "static/media/left-arrow.6b1fac37.svg";